import templateUrl from './project-list.html'
import './project-list.scss'

const NOTIFICATIONS_CHANNEL = 'notifications'
const TEAM_MEMBERSHIP_EVENTS = ['ad_hoc_team_member_added', 'ad_hoc_team_member_removed']

const ProjectListComponent = {
  bindings: {},
  templateUrl,
  controller: class ProjectList {
    constructor ($window, $state, $stateParams, $scope, ProjectDashboardService, EventBusService) {
      'ngInject'
      this._identify = 'ProjectListComponent'
      this.$window = $window
      this.$state = $state
      this.$stateParams = $stateParams
      this.$scope = $scope
      this.ProjectDashboardService = ProjectDashboardService
      this.EventBusService = EventBusService

      this.isLoading = false
      this.projectList = null
    }

    $onInit () {
      this.ProjectDashboardService.init()
      this.loadProjectList()
      this.bindMembershipEvents()
    }

    $onDestroy () {
      this.unbindMembershipEvents()
    }

    bindMembershipEvents () {
      this._membershipHandler = () => {
        // Membership change for the current user → refetch the dashboard list.
        this.$scope.$applyAsync(() => this.loadProjectList())
      }
      TEAM_MEMBERSHIP_EVENTS.forEach(eventName => {
        this.EventBusService.channel(NOTIFICATIONS_CHANNEL).subscribe(eventName, this._membershipHandler)
      })
    }

    unbindMembershipEvents () {
      if (!this._membershipHandler) return
      TEAM_MEMBERSHIP_EVENTS.forEach(eventName => {
        this.EventBusService.channel(NOTIFICATIONS_CHANNEL).unsubscribe(eventName, this._membershipHandler)
      })
      this._membershipHandler = null
    }

    get pagination () {
      return this.ProjectDashboardService.pagination
    }

    loadProjectList () {
      this.$window.document.querySelector('cdbl-project-dashboard .content-inner-wrapper').scrollTo({ top: 0 })
      this.isLoading = true
      this.ProjectDashboardService.getProjectList()
        .then(response => {
          console.log('[ProjectListComponent] > loadProjectList', response)
          this.projectList = response
        })
        .finally(() => {
          this.isLoading = false
        })
    }

    onPageChangeHandler (page) {
      console.log('[ProjectListComponent] > onPageChangeHandler', page)
      this.ProjectDashboardService.updateQueryString()
    }


    removeProjectFromList (projectId) {
      if (this.projectList) {
        const index = this.projectList.findIndex(p => p.id === projectId)
        if (index > -1) {
          this.projectList.splice(index, 1)
        }

        console.log('[ProjectListComponent] > removeProjectFromList > index', index)
      }
    }
  }
}

export default ProjectListComponent
